//https://cdnjs.cloudflare.com/ajax/libs/parallax/3.1.0/parallax.min.js
( function ( _s ) {
	/* 
		https://web.dev/articles/intersectionobserver-v2
		Using the InteractionObserver API I can check if a parallax-scene is visible,
		and THEN I load the library and initialize the element. That way I don't load 
		the library on page load while the element is not visible yet. Small optimization.
	*/
	let observedElements = new Set();

	const observeElement = () => {
		const parallaxScenes = document.querySelectorAll( '.parallax-scene' );

		parallaxScenes.forEach( scene => {
			if ( scene ) {
				const observer = new IntersectionObserver( entries => {
					if ( entries[ 0 ].isIntersecting && ! observedElements.has( scene ) ) {
						observedElements.add( scene );
						loadLibAndInitialize( scene );
					}
				} );

				observer.observe( scene );
			}
		} );
	};

	const loadLibAndInitialize = parallaxScene => {
		if ( window.Parallax !== undefined ) {
			_s( parallaxScene ).frParallaxScene();
		} else {
			window
				.fetchInject( [
					'https://cdnjs.cloudflare.com/ajax/libs/parallax/3.1.0/parallax.min.js',
				] )
				.then( () => {
					_s( parallaxScene ).frParallaxScene();
				} );
		}
	};

	_s.fn.frParallaxScene = function () {
		return this.each( el => {
			const _self = _s( el );
			const instance = new Parallax( _self.el[ 0 ] );
		} );
	};

	_s( document ).ready( () => {
		observeElement();
	} );
} )( window._s );
